import type { ReactNode } from 'react'
import { View, type ViewProps } from 'react-native'

import { cn } from '@/src/general/utils/cn'

import { placeholderLine, type TPlaceholderLineVariantProps } from './PlaceholderLine.variant'

type TPlaceholderLineProps = ViewProps & TPlaceholderLineVariantProps

export const PlaceholderLine = ({ className = '', testID, ...rest }: TPlaceholderLineProps): ReactNode => (
  <View className={cn(placeholderLine(rest), className)} testID={testID} />
)

export const PlaceholderLines = ({ nb, ...rest }: TPlaceholderLineProps & { nb: number }): ReactNode => (
  <>
    {Array.from({ length: nb }, (_, index) => (
      <PlaceholderLine key={index} {...rest} />
    ))}
  </>
)
